import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';
import { WorkingHours } from 'src/app/models/persona/profile/workingHours';
import { ToastService } from 'src/app/services/toast.service';
import { FormArray, UntypedFormGroup } from '@angular/forms';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { HttpClient } from '@angular/common/http';
import { scrollToFirstInvalidControl } from 'src/app/utils/scrollToFirstInvalidControl';
import { ApcSectionAnchorsComponent } from '../apc-section-anchors/apc-section-anchors.component';
import { clearErrors } from 'src/app/utils/clearFormErrors';
import { Router } from '@angular/router';
import { BudgetService } from '../../user/order/budget/service/budget.service';

@Component({
    selector: 'apc-multi-forms',
    templateUrl: './multi-forms.component.html',
    styleUrls: ['./multi-forms.component.scss'],
    providers: [BudgetService],
    standalone: false
})
export class MultiFormsComponent implements OnInit{
  public data: WorkingHours[] = [];
  //public form: UntypedFormGroup;
  @Input() forms: FormArray<any>;
  public submitFailed = false;
  public allCollapsed = false;
  public canCollapse: boolean = false;
  private firstLoad: boolean = true;
  @Output() addTitleToCollapsableEvent = new EventEmitter<any>();
  @Output() calculateTotalHoursPercentageEvent = new EventEmitter<any>();
  @Output() fillFullTimeEvent = new EventEmitter<any>();
  @Output() toggleEdit = new EventEmitter<any>();
  @Output() saveSuccess = new EventEmitter<any>();
  @Output() newProjectEvent = new EventEmitter<any>();
  @Output() newBudgetFillEmmiter = new EventEmitter<any>();
  @Output() rightIconEvent = new EventEmitter<any>();
  @Input() public newEmptyForm: any;
  @Input() public newDataForm: any;
  @Input() public getData: Function;
  @Input() public getDataSearch: Function;
  @Input() public createData: Function;
  @Input() public updateData: Function;
  @Input() public deleteData: Function;
  @Input() public user_id: string;
  @Input() public showHeaderIcon: boolean = true;
  @Input() public showRowIcon: boolean = true;

  @Input() formTemplate: TemplateRef<any>;
  @Input() header: string;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() icon: string = '';
  @Input() rightIcon: string = '';

  @Input() openedId: string = null;
  @ViewChild(ApcSectionAnchorsComponent) sectionAnchors: ApcSectionAnchorsComponent;
  @ViewChild('toggle') toggle: ElementRef;
  public workingdays;
  public recordsCount;
  public recordQuery;
  public page = 1;
  public orderId;
  public searchValueBudget: string = '';
  public budgets = [];
  public isLoading: boolean = false;
  public isOpen: boolean = false;

  constructor(
    private readonly router: Router,
    public http: HttpClient,
    private readonly toastService: ToastService,
    public cdr: ChangeDetectorRef,
    private readonly el: ElementRef,
    private readonly budgetService: BudgetService
  ) {
  }

  ngOnInit() {
    let urlFragments = this.router.url.split('/');
    this.orderId = this.router.url.split('/')[2];
    const budgetIndex = urlFragments.indexOf('budget');
    const openedId = budgetIndex === -1 ? null : urlFragments[budgetIndex + 1];

    this.initData(1, openedId);
  }

  async initData(page, openedBudget = '') {
    this.page = page;
    this.data = [];
    while (this.forms.length) {
      this.forms.removeAt(0);
    }

    if (this.section == "budget" && this.searchValueBudget.length > 2) {
      this.data = await this.getDataSearch(this.orderId, page, this.searchValueBudget);
    } else {
      this.data = await this.getData(this.user_id, page, openedBudget);
    }

    //Aggiorno il numero di record della lista da mostrare in pagina 
    this.refresh_RecordsCount_fromCurrentData();
    //Aggiorno la variabile che tiene il numero totale di record utile a mostra la paginazione o no
    this.refresh_RecordQuery_fromCurrentData();
    //Setto i form
    this.setForm_fromCurrentData();

    this.addTitleToCollapsable(false);
    this.closeAll();
    if (this.openedId) {
      this.toggleElement(this.openedId, true);
    }
    this.calcTotalHours(false);
    if (openedBudget) {
      this.seacrhBudgetName();
      this.searchValueBudget = openedBudget;
    }
  }

  setForm_fromCurrentData(){
    if (this.data['page']) {
      this.data['page']['content'].forEach((el) => {
        this.forms.push(this.newDataForm(el));
      });
    } else {
      this.data.forEach((el) => {
        this.forms.push(this.newDataForm(el));
      });
    }
  }

  refresh_RecordsCount_fromCurrentData() {
    const count = Object.hasOwn(this.data, 'page') 
                  ? this.data['totalBudgets'] 
                  : this.data.length;
    this.setRecordsCount(count);
  }
  getRecordsCount() { return this.recordsCount; }
  setRecordsCount(val: number = 0) { this.recordsCount = val; }

  refresh_RecordQuery_fromCurrentData() {
    const total = this.data?.['page']?.['page']?.['totalElements'] ?? 0;
    this.setRecordQuery(total);
  }
  getRecordQuery() { return this.recordQuery; }
  setRecordQuery(val: number = 0) { this.recordQuery = val; }

  async calcTotalHours(loadAll: boolean) {
    if (loadAll) {
      this.data = await this.getData(this.user_id);
    }

    if (this.section === 'product') {
      let totalHours = 0;
      this.data.forEach((item: any) => {
        totalHours += item.quantity;
      });
      this.workingdays = this.reformatProductSingleHours(totalHours);
    }

    if (this.section === 'budget') {
      let totalHours = 0;
      
      if (this.data?.['page']?.['content']) {
        totalHours = this.data['totalOrdered'];
      } else {
        this.data.forEach((item: any) => {
          item.budgetProducts = this.sortProducts(item.budgetProducts);
          item.budgetProducts.forEach((budget: any) => {
            totalHours += budget.quantity;
          });
        });
      }

      this.workingdays = this.reformatProductSingleHours(totalHours);
      return this.data;
    }
  }

  sortProducts(item) {
    return item.sort(function (a, b) {
      if (a.product.code < b.product.code) {
        return 1
      } else if (a.product.code > b.product.code) {
        return -1;
      } else {
        return 0;
      }
    });

  }

  reformatProductSingleHours(hours: number) {
    return hours && Number(hours) > 0
      ? '[ ' + Number(hours).toFixed(2) + 'h | ' + Number(hours / 8).toFixed(2) + 'd ]'
      : null;
  }

  toggleAll() {
    this.allCollapsed = !this.allCollapsed;
    this.firstLoad = true;
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = this.allCollapsed;
    });
  }

  closeAll() {
    this.allCollapsed = true;
    this.firstLoad = true;
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = this.allCollapsed;
    });
  }

  setToggle() {
    this.toggleOthers();
    let canToggle = Object.values(this.forms.controls).filter((value: any) => value.isCollapsed === true).length === 3;
    if (!canToggle) {
      this.canCollapse = true;
    } else {
      this.allCollapsed = true;
      this.canCollapse = false;
    }
  }

  toggleOthers() {
    !this.allCollapsed &&
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === this.openedId && this.firstLoad) {
          this.firstLoad = false;
          this.toggleElement(item.value.identifier, false);
        } else if (item.value.identifier === this.openedId && !this.firstLoad) {
          item.isCollapsed = true;
          this.allCollapsed = true;
        }
      });
  }

  toggleElement(elemId: string, firstLoad: boolean) {
    this.openedId = elemId;
    let fragments = window.location.pathname.split('/');
    let sectionIndex;

    fragments.forEach((f, i) => {
      if (f == this.section) {
        sectionIndex = i;
      }
    });
    // toggle urls between same multisection
    if (window.location.pathname.includes(this.subsection) && !firstLoad) {
      let idToReplace = fragments.findIndex((el) => el === this.subsection) + 1;
      fragments[idToReplace] = elemId;
    }
    // check if we were on another multisection on current page
    else if (fragments.length >= sectionIndex + 1 && !firstLoad) {
      fragments[sectionIndex + 2] = this.subsection;
      fragments[sectionIndex + 3] = elemId;
    } else if (!firstLoad) {
      fragments.push(this.subsection);
      fragments.push(elemId);
    }
    window.history.replaceState({}, '', fragments.join('/'));
    if (window.location.pathname.includes(this.subsection)) {
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === elemId) {
          item.isCollapsed = !item.isCollapsed;
        } else {
          item.isCollapsed = true;
        }
      });
    }
  }

  addNewSection() {
    // going to check if we already have some epty form
    let emptyAlreadyExists = false;
    this.forms.controls.forEach((item) => {
      if (!item.value.identifier) {
        emptyAlreadyExists = true;
      }
    });
    // add new form only if we dont have any empty form initialized
    if (!emptyAlreadyExists) {
      this.forms.push(this.newEmptyForm());
      this.forms.controls.forEach((formControl: any) => {
        // if the form is new/being created, put it to edit mode
        if (!formControl.value.identifier) {
          formControl.editForm = true;
          this.newSectionBlanket();
        }
      });
    }
  }

  async saveForm(form: any) {
    if (!form.valid && !this.submitFailed) {
      this.toastService.showError('Operation error!');
      form.markAsPristine();
      form.markAllAsTouched();
      return; 
    }

    try {
      let newItem = null;
      let isNewItem = false; 

      if (form.value.identifier) {
        // Editing
        newItem = await this.updateData(this.user_id, form.value);
        if (newItem?.['completion']) {
          newItem['completion'] = newItem['completion'] * 100;
        }
        if (newItem?.['bo']) {
          newItem['bo'] = { identifier: newItem['bo'], code: newItem['bo'], name: newItem['bo'] };
        }
      } else {
        // Creating new
        isNewItem = true;
        newItem = await this.createData(this.user_id, form.value);
      }

      form.patchValue(newItem);
      form.updateValueAndValidity();
      form.markAsPristine();
      form.editForm = false;
      this.addTitleToCollapsable();
      this.toastService.showSuccess('Operation success!');
      clearErrors(form);
      form.markAsUntouched();

      if (isNewItem) {
        this.redirect(newItem['identifier'], newItem);
      }

      document.getElementById('blanket')?.classList.add('d-none');
      document.querySelector('.blanket-active')?.classList.remove('blanket-active')
      this.saveSuccess.emit(true);
      this.calcTotalHours(true);

    } catch (e) {
      clearErrors(form);
      this.submitFailed = true;
      this.toastService.showError('Operation error!');
      if (e.validationErrors?.length > 0) {
        form.markAsPristine();
        checkForValidationErrors(e, form);
        scrollToFirstInvalidControl(this.el);
      }
    }
  }

  async cancelForm(item) {
    // if canceling form that exists (edit form), fetch old form data and replace that data with current data that we want to cancel
    if (item.value.identifier) {
      const index = this.forms.controls.findIndex((p) => p.value.identifier === item.value.identifier);
      this.data = await this.getData(this.user_id);
      if (this.data['page']) {
        this.data = this.data['page']['content'];
      }
      let oldHour = this.data.find((h) => h.identifier == item.value.identifier);
      let form = this.newDataForm(oldHour);
      form.editForm = false;
      this.forms.controls[index] = form;
      this.addTitleToCollapsable();
    }
    // if canceling form that does not exist (new form), just remove it from the list
    else {
      this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== null);
    }

    // Emit undo EditMode Enabled
    this.onEdit(item, false);
  }

  async cloneForm(item) {
    this.data = await this.getData(this.user_id);
    let hoursToClone = this.data.find((h) => h.identifier == item.value.identifier);
    // copying object, removing references to the object we copied from
    let clonedHours = JSON.parse(JSON.stringify(hoursToClone));
    // puting id to null beacuse it is a new form
    clonedHours.identifier = null;
    // pushing to the forms list
    this.forms.push(this.newDataForm(clonedHours));
    this.addTitleToCollapsable();
    // opening new form for editing mode
    this.forms.controls.forEach((item: any) => {
      // if the form is new/being created, put it to edit mode
      if (!item.value.identifier) {
        item.editForm = true;
        this.newSectionBlanket();
      }
    });
  }

  async delete(subsectionIdentifier: string) {
    await this.deleteData(this.user_id, subsectionIdentifier);

    this.calcTotalHours(true);

    this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== subsectionIdentifier);
    this.recordsCount = this.forms.controls.length;

    this.resetIds();
    this.toastService.showSuccess('Operation success!');
  }

  resetIds() {
    this.forms.controls.forEach((el, index) => {
      if (document.getElementById(el.value.identifier)) {
        let row: any = document.getElementById(el.value.identifier);
        row.getElementsByTagName("div")[0].id = this.subsection + '-row-' + index;
      }
    })
  }

  async addTitleToCollapsable(recalculateHour: boolean = true) {
    this.resetIds();
    this.addTitleToCollapsableEvent.emit(this.forms);

    if (recalculateHour) {
      await this.calcTotalHours(true);
    }
    if (this.section == 'budget') {
       //Aggiorno il numero di record della lista da mostrare in pagina 
      this.refresh_RecordsCount_fromCurrentData();
      //Aggiorno la variabile che tiene il numero totale di record utile a mostra la paginazione o no
      this.refresh_RecordQuery_fromCurrentData();
    }
  }






  calculateTotalHoursPercentage(form: UntypedFormGroup) {
    this.calculateTotalHoursPercentageEvent.emit();
  }

  fillFullTime(item) {
    this.fillFullTimeEvent.emit(item);
    item.markAsDirty();
  }

  toggleExpandedClass(toggle) {
    let toggleEl: HTMLDivElement = <HTMLDivElement>this.toggle.nativeElement;
    if (toggle) {
      toggleEl.classList.remove('toggle-shrinked');
      toggleEl.classList.add('toggle-expanded');
    } else if (this.allCollapsed) {
      toggleEl.classList.remove('toggle-expanded');
      toggleEl.classList.add('toggle-shrinked');
    }
  }

  onEdit(item, event) {
    this.manageBlanket(item.value.identifier, event);
    item.editForm = event;
  }

  public editModeArray = [];
  manageBlanket(itemId: string, isEdit: boolean) {
    let rowId;
    if (itemId) {
      rowId = this.forms.controls.findIndex((control) => control.value.identifier == itemId);
    } else {
      rowId = this.forms.controls.length - 1;
    }
    if (isEdit === false) {
      this.editModeArray = this.editModeArray.filter((obj) => obj !== isEdit);
      document.getElementById('blanket').classList.add('d-none');
      document.getElementById(this.subsection + `-row-${rowId}`)?.classList.remove('blanket-active');
    } else if (isEdit === true) {
      this.editModeArray.push(itemId);
      document.getElementById('blanket').classList.remove('d-none');
      document.getElementById(this.subsection + `-row-${rowId}`)?.classList.add('blanket-active');
    }
  }

  newSectionBlanket() {
    setTimeout(() => {
      document.getElementById('blanket').classList.remove('d-none');
      const newElementId = this.subsection + `-row-${this.forms.controls.length - 1}`;
      document.getElementById(newElementId).classList.add('blanket-active');
      document.getElementById(newElementId).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
    }, 400);
  }

  newProduct(item) {
    if (!item.controls.budgetProducts.value) {
      item.controls.budgetProducts.value = [];
    }
    item.controls.budgetProducts.value.push({ identifier: null, product: null, quantity: null });
    setTimeout(() => {
      let elId = 'new-budget-product';
      document.getElementById(elId).getElementsByTagName('button')[0].click();
      document.getElementById(elId).scrollIntoView({ behavior: 'smooth' });
    }, 200);
  }

  newProject(id: string, project: any) {
    this.newProjectEvent.emit({ budgetId: id, projectId: project ? project.identifier : null });
  }

  newBudgetFill(id: string) {
    this.newBudgetFillEmmiter.emit(id);
  }

  returnDeleteText(projectName) {
    if (projectName)
      return (
        'Project <b>' +
        projectName +
        '</b> is currently linked to this budget.<br/>Are you sure you want to delete this budget?<br/>The delete operation will automatically unlink the project.'
      );
    return 'Are you sure to delete this item?';
  }

  pageChange() {
    this.initData(this.page);
  }

  seacrhBudgetName() {
    this.isOpen = true;
    setTimeout(() => document.getElementById('quick-search-budget').focus(), 200);
  }

  closeSearchBudget() {
    this.isOpen = false;
    this.budgets = [];
    this.searchValueBudget = '';
    this.redirect('');
  }

  redirect(idgeneric: string, genericObj: any = null) {
    let finalUrl = 'order/' + this.orderId;
    
    if (genericObj && idgeneric) {
      if (genericObj['product'] === undefined) {
        finalUrl += '/budget/' + idgeneric;
      } else {
        finalUrl += '/product/' + idgeneric;
      }
    }

    // RIPRISTINO DEL RELOAD ORIGINALE (Sintassi Arrow Function approvata da SonarQube)
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    
    // Navigazione pulita senza sporcare l'URL con parametri di refresh
    this.router.navigate([finalUrl]);

    this.searchValueBudget = '';
    this.budgets = [];
    this.isOpen = false;
  }

  search(event) {
    if (event.keyCode === 13 && this.searchValueBudget.length > 2) {
      this.isLoading = true;
      this.budgets = [];
      this.initData(1);
    }
    else {
      this.budgets = [];
      this.isLoading = false;
    }
  }



  deleteBudgetEvent(event:any){
    this.closeSearchBudget();
  }
}
